<template>

        <FinancialComponent />

</template>

<script>
import FinancialComponent from '../components/FinancialComponent.vue'
export default {
  components: {
    FinancialComponent
  },
    data() {
    return {

    }
  }
}


</script>

<style scoped>

</style>
